<div class="offer-update-dialog">
    <div class="offer-update-dialog__header">
        <div *ngIf="additionalLogoUrl" class="offer-update-dialog__additional-logo">
            <img [src]="additionalLogoUrl" alt="">
        </div>
        <div *ngIf="additionalLogoUrl" class="offer-update-dialog__divider"></div>
        <div *ngIf="logoVisible" class="offer-update-dialog__logo">
            <img [src]="logoUrl" alt="">
        </div>
    </div>
    <div class="offer-update-dialog__title"
         [innerHTML]="getTranslationKey('title') | translate | safeHtml"
    ></div>
    <div class="offer-update-dialog__image">
        <img [src]="imageUrl" alt="">
    </div>
</div>
